import smsVerificationController from './sms-verification-controller';
export default function (app) {
	app.component('smsVerification', {
		transclude: true,
		bindings: {
			sendSmsButtonFunction: '&',
			sendNewSmsFunction: '&',
			cancelButtonActionFunction: '&',
			removeWrongSmsCodeFunction: '&?',
			notReceived: '=',
			countDownSeconds: '=',
			serviceNotAvailable: '=',
			smsForm: '=',
			phone: '<',
			additionalParam: '<',
			smsCode: '<',
			submitButtonState: '<',
			successCallback: '&'
		},
		templateUrl: function ($element, $attrs) {
			switch ($attrs.template) {
				case 'onboarding':
					return 'common/sms-verification-onboarding';
				case 'transaction' :
					return 'common/sms-verification-transaction';
				case 'user' :
					return 'common/sms-verification-user';
				case 'password' :
					return 'common/sms-verification-password';
				case 'linked-payment' :
					return 'common/sms-verification-linked-payment';
				default:
					return 'common/sms-verification-user';
			}
		},
		controller: ['$timeout', '$interval', 'pageContext', smsVerificationController]
	});
};
